import { useMemo } from 'react';
import { sortBy } from 'lodash-es';
import { parseJsonSafely } from '../../ChatPage/utils';
import { useRequestController } from './useRequestController.ts';

/**
 * AI 智能表格推荐问题数据 Hook
 * 请求 rainbow 配置接口，解析并返回推荐问题分类数据
 */
const useAISmartTableData = () => {
  const aiSmartTableData = useRequestController({
    method: 'POST',
    url: `/api/v1/permission/rainbow`,
    refreshDeps: useMemo(() => ({ key: '', group: 'agent.aI_smart_table' }), []),
    // 默认2个小时不发起请求
    staleTime: 7200000,
    cacheKey: 'agent-aI_smart_table',
  });

  // 解析 AI 智能表格的推荐问题数据
  const aiTableRecommendData = useMemo(() => {
    const rows = aiSmartTableData?.data?.rows;
    if (!rows) return [];
    const dataSource = rows.map((row: any) => {
      const parsedValue = parseJsonSafely(row.value);
      const merged = {
        id: row.key,
        ...row,
        ...parsedValue,
      };
      // 适配新数据结构：将 recommendQuestions 映射为 Recommend 组件所需的 data 字段
      if (merged.recommendQuestions && !merged.data) {
        merged.data = merged.recommendQuestions;
      }
      return merged;
    });
    return sortBy(dataSource, ['sort']);
  }, [aiSmartTableData?.data?.rows]);
  return {
    aiTableRecommendData,
    loading: aiSmartTableData?.loading ?? false,
  };
};

export default useAISmartTableData;
